import { NgModule } from '@angular/core';
import { ConnectivitiesRoutingModule } from './connectivities-routing.module';
import { TrainConnectivityReportComponent } from './components/train-connectivity-report/train-connectivity-report.component';
import { SharedModule } from "../../shared/shared.module";
import { UIRouterModule } from "@uirouter/angular";
import { CONNECTIVITY_STATES } from "./connectivities.states";
import { SelectedItemPipe } from './pipes/selected-item.pipe';
import { TodayDateSelectedPipe } from './pipes/today-date-selected.pipe';


@NgModule({
  declarations: [TrainConnectivityReportComponent, SelectedItemPipe, TodayDateSelectedPipe],
  imports: [
    ConnectivitiesRoutingModule,
    SharedModule,
    UIRouterModule.forChild({ states: [...CONNECTIVITY_STATES] }),
  ]
})
export class TrainConnectivityModule { }
